import { SettingsEditButton } from 'App/Map/UserSettingsMenu/components/SettingsEditButton/SettingsEditButton'
import type { TAvailablePreset } from 'stores/userDetailsStore/helperTypes'

export const EditPresetButton = ({
  editPreset,
  preset,
}: {
  editPreset: (a: TAvailablePreset) => void
  preset: TAvailablePreset
}) => {
  return (
    <SettingsEditButton
      onClick={() => {
        editPreset(preset)
      }}
    />
  )
}
